import { BionicNavigation, userHasValidRolesForNavItem } from '@/assets/js/constants/navigation'
import { defineNuxtRouteMiddleware, useNuxtApp, createError, showError } from 'nuxt/app'

export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp()

  for (const navNode of BionicNavigation) {
    const isPage = to.path.includes(navNode.link) || to.fullPath.includes(navNode.link)
    if (isPage && !userHasValidRolesForNavItem(navNode, nuxtApp.$store.getters.user)) {
      throw createError({ statusCode: 404, message: 'This page does not exist', fatal: true })
    }
  }
})
